<div class="flex flex-col gap-1" data-test-class="filter-group">
	<span [id]="groupName() + '-label'" class="font-semibold">
		{{ 'compositions.filters.type.' + title() + '.label' | translate }}
	</span>
	<div
		[attr.aria-labelledby]="groupName() + '-label'"
		class="flex flex-col gap-3"
		role="radiogroup"
	>
		@for (filterItem of options(); track filterItem.value) {
			<div class="flex flex-row">
				<vp-radio
					[checked]="activeValue() === filterItem.value"
					[disabled]="filterItem.disabled"
					[inputId]="groupName() + '-' + filterItem.value"
					[name]="groupName()"
					[value]="filterItem.value"
					(selected)="onSelect($event)"
					class="w-full"
				>
					{{ filterItem.name }}
				</vp-radio>
				<span
					[class]="cn(filterItem.disabled && 'text-dark-quaternary')"
				>
					{{ filterItem.frequency }}
				</span>
			</div>
		}
		@if (collapsible.hasMoreItems()) {
			<button
				(click)="collapsible.showMore()"
				class="w-fit underline"
				data-test-class="show-more"
			>
				{{ 'global.show-more' | translate }}
			</button>
		}
	</div>
</div>
